/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, doT) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 */

	'use strict';
	/*globals Tc */
	var extReg = /^.*(\.[a-zA-Z0-9]*)$/;

	/**
	 * FileUpload module implementation.
	 *
	 * @author Renaldas Szentiks
	 * @namespace Tc.Module
	 * @class FileUpload
	 * @extends Tc.Module
	 */
	Tc.Module.FileUpload = Tc.Module.extend({
		/**
		 * Initializes the module.
		 *
		 * @method init
		 * @constructor
		 * @param {jQuery} $ctx the jquery context
		 * @param {Sandbox} sandbox the sandbox to get the resources from
		 * @param {String} modId the unique module id
		 */
		init: function ($ctx, sandbox, modId) {
			this._super($ctx, sandbox, modId);
			this.fileList = $('.fileList', this.$ctx);
			this.name = this.getUploadField().data('name');
			this.url = this.$ctx.data('url');
			this.SizeCalculator.init(this.$ctx.data('size-limit'), this.$ctx.data('file-size-limit'));
			this.generateLinks = this.$ctx.data('generate-links') === true || this.$ctx.data('generate-links') === 'true';
			this.actionProvider = this.$ctx.data('action-provider');
			this.maxUploadFiles = this.$ctx.data('max-uploads');
			this.noOfUploadedFiles = 0;
			var dataExt = this.$ctx.data('allowed-extensions');
			this.allowedExtensions = dataExt ? dataExt.split(', ') : [];
			this.sdxStyle = this.$ctx.data('sdx-style');
		},

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			this.getUploadField().on('change', $.proxy(this.changeHandler, this));
			this.getUploadField().on('prefill', $.proxy(this.prefillHandler, this));
			this.getUploadField().on('resetFiles', $.proxy(this.removeAllFilesHandler, this));
			this.getUploadField().on('click', this.checkMaxUploads.bind(this));
			this.$ctx.find('.upload-button').on('click', this.triggerUploadFieldClick.bind(this));

			if(this.sdxStyle) {
				this.$errorMessageHolder = this.$ctx.find('.error-message');
				this.getUploadField().on('click', this.hideErrorMessage.bind(this));

				this.preventErrorMessageHide = false;
				this.hideErrorMessage();
			}
			var $itemTmplContent = this.$ctx.find('script.tmpl-uploaded-element');
			this.itemTmpl = doT.template($itemTmplContent.html());
			this.uploadedFiles = [];
			callback();
		},

		after: function () {
			this.$ctx.trigger('randomFormToken', {action: 'generate', cb: $.proxy(this.onRandomFormToken, this)});
		},

		onRandomFormToken: function (data) {
			if (data && data.action === 'set') {
				this.randomFormToken = data.token;
			}
		},

		/**
		 * This function checks if the allowed number of uploads is reached. If
		 * maximum number of uploads is reach it prevents uploading new file.
		 *
		 * @method checkMaxUploads
		 * @return {Boolean}
		 */
		checkMaxUploads: function () {
			if (this.maxUploadFiles && this.noOfUploadedFiles >= this.maxUploadFiles) {
				this.showDialog('Error', this.$ctx.data('error-upload-limit').replace('{0}', this.maxUploadFiles));
				this.preventErrorMessageHide = true;
				return false;
			}
			return true;
		},

		/**
		 * This function adds information of uploaded files.
		 * These information are stored in `uploadedFiles` property which is array
		 * of objects that contains uploaded file path and uuid.
		 *
		 * @method addItemToUploadedFileList
		 * @param fileName {String} File name that is uploaded
		 * @param uuid {String} Uploaded file uuid
		 * @return void
		 */
		addItemToUploadedFileList: function (fileName, uuid) {
			this.uploadedFiles.push({
				fileName: fileName.toLowerCase(),
				uuid: uuid
			});
		},

		/**
		 * This function removes information of uploaded files.
		 * These information are stored in `uploadedFiles` property which is array
		 * of objects that contains uploaded file path and uuid.
		 *
		 * @method removeItemFromUploadedFileList
		 * @param uuid {String} Uploaded file uuid
		 * @return void
		 */
		removeItemFromUploadedFileList: function (uuid) {
			var mod = this;
			this.uploadedFiles.some(function (item, i) {
				if (item.uuid === uuid) {
					mod.uploadedFiles.splice(i, 1);
					return true;
				}
				return false;
			});
		},

		/**
		 * Check if file with given name is already loaded.
		 *
		 * @method checkIfFileIsUploaded
		 * @param fileName {String} File name that is uploaded
		 * @return {Boolean}
		 */
		checkIfFileIsUploaded: function (fileName) {
			return this.uploadedFiles.some(function (item) {
				return (item.fileName === fileName);
			});
		},

		/**
		 *
		 *
		 * @method getUploadFileName
		 * @param filepath {String} Path to the file that is uploaded
		 * @return {String} Upload file name with extension
		 */
		getUploadFileName: function (filepath) {
			return filepath.split('\\').pop().split('/').pop();
		},

		/**
		 * This function triggers click event on upload field.
		 *
		 * @method triggerUploadFieldClick
		 * @param {Event} evt Click event
		 * @return void
		 */
		triggerUploadFieldClick: function (evt) {
			if(evt) {
				evt.preventDefault();
				evt.stopPropagation();
			}
			this.getUploadField().click();
		},

		/**
		 * This function sets value of upload field to empty string.
		 *
		 * @method resetUploadField
		 * @return void
		 */
		resetUploadField: function () {
			this.getUploadField().val('');
		},

		/**
		 * This function displays error message.
		 *
		 * @method showErrorMessage
		 * @param {String} message Error mesage to be displayed
		 * @return void
		 */
		showErrorMessage: function (message) {
			this.$errorMessageHolder.removeClass('is-hidden');
			this.$errorMessageHolder.text(message);
		},

		/**
		 * This function hides error message.
		 *
		 * @method hideErrorMessage
		 * @return void
		 */
		hideErrorMessage: function () {
			if (!this.preventErrorMessageHide) {
				this.$errorMessageHolder.addClass('is-hidden');
				this.$errorMessageHolder.empty();
			} else {
				this.preventErrorMessageHide = false;
			}
		},

		getName: function () {
			return this.name;
		},

		getUrl: function () {
			return this.url;
		},

		getUploadField: function () {
			return $('input[type="file"]', this.$ctx);
		},

		showDialog: function (title, text) {
			if(this.sdxStyle) {
				this.showErrorMessage(text);
			} else {
				$('<div/>').attr('title', title).append(text).dialog();
			}
		},

		changeHandler: function (event) {
			if (event) {
				event.preventDefault();
			}
			var filePath = this.getUploadField().val();
			this.uploadFileName = this.getUploadFileName(filePath);
			if (filePath) {
				var fileExt = extReg.exec(this.uploadFileName);
				if(!fileExt || !fileExt[1]) {
					this.showDialog('Error', this.$ctx.data('error-missing-extension'));
					this.resetUploadField();
					return;
				}
				if(this.allowedExtensions.length && !this.allowedExtensions.some(function (ext) { return ext === fileExt[1].toLowerCase();})) {
					this.showDialog('Error', this.$ctx.data('error-wrong-extension').replace('{0}', fileExt[1]).replace('{1}', this.allowedExtensions.join(', ')));
					this.resetUploadField();
					return;
				}
				if(this.checkIfFileIsUploaded(this.uploadFileName.toLowerCase())) {
					this.showDialog('Error', this.$ctx.data('error-already-uploaded').replace('{0}', this.uploadFileName));
					this.resetUploadField();
					return;
				}
				this.uploadFile(this.getUploadField());
			}
		},

		prefillHandler: function (event, data) {
			if (data) {
				if (Array.isArray(data.items)) { // array of attachments
					this.noOfUploadedFiles = data.items.length;
					for (var i = 0; i < data.items.length; i += 1) {
						this.appendFileEntry(data.items[i]);
					}
				} else { // single attachment
					this.noOfUploadedFiles = 1;
					this.appendFileEntry(data);
				}
			}
		},

		uploadResponseHandler: function (response) {
			this.resetUploadField();
			if (response.success === true || response.success === 'true') {
				this.noOfUploadedFiles += 1;
				this.appendFileEntry(response.item);
				this.addItemToUploadedFileList(this.uploadFileName, response.item.uuid);
			} else {
				if (response.errorMessage) { // unknown error
					this.showDialog('Error', response.errorMessage);
				} else if (response.errorCode === '1' || response.errorCode === 1) { // file size too big
					this.showDialog('Error', this.$ctx.data('error-file-size-limit').replace('{0}', this.formatSize(this.SizeCalculator.getFileSizeLimit())));
				} else if (response.errorCode === '2' || response.errorCode === 2) { // empty file
					this.showDialog('Error', this.$ctx.data('error-file-empty'));
				}
			}
			this.uploadFileName = '';
		},

		appendFileEntry: function (data) {
			if (data && typeof data.uuid !== 'undefined') {
				var sizeStatus = this.SizeCalculator.add(data.size);
				if (sizeStatus.ok && sizeStatus.fileOk) {
					var name = data.fileName ? data.fileName : data.uuid,
						url = this.generateLinks ? this.getUrl() + '?uuid=' + data.uuid : '';
					var $uploadItem = $(this.itemTmpl({
						url: url,
						name: name,
						generateLinks: this.generateLinks,
						size: this.formatSize(data.size),
						uploadFieldName: this.getName(),
						uuid: data.uuid
					}));
					this.fileList.append($uploadItem);

					var removeIcon = $uploadItem.find('.remove-icon');
					removeIcon.on('click', {uuid: data.uuid, entry: $uploadItem}, this.removeFileHandler.bind(this));
				} else {
					this.SizeCalculator.remove(data.size);
					if (!sizeStatus.ok) {
						this.showDialog('Error', this.$ctx.data('error-size-limit').replace('{0}', this.formatSize(this.SizeCalculator.getSizeLimit())));
					} else {
						this.showDialog('Error', this.$ctx.data('error-file-size-limit').replace('{0}', this.formatSize(this.SizeCalculator.getFileSizeLimit())));
					}
				}
			}
		},

		formatSize: function (size) {
			if (size) {
				size = parseInt(size, 10);
				if (!isNaN(size) && size > 1024) {
					var suffix = 'kB';
					size = size / 1024;
					if (size >= 1024) {
						size = size / 1024;
						suffix = 'MB';
					}
					size = Math.round(size * 10) / 10;
					return size + suffix;
				} else {
					return '1kB';
				}
			}
			return '0kB';
		},

		removeAllFilesHandler: function () {
			this.noOfUploadedFiles = 0;
			this.uploadFileName = '';
			this.uploadedFiles = [];
			this.fileList.empty();
			if (this.sdxStyle) {
				this.hideErrorMessage();
			}
		},

		removeFileHandler: function (event) {
			if (event) {
				event.preventDefault();
			}
			var $this = this,
				uuid = event.data.uuid,
				listEntry = event.data.entry;

			listEntry.remove();
			this.noOfUploadedFiles -= 1;

			this.removeItemFromUploadedFileList(uuid);
			if (this.sdxStyle) {
				this.hideErrorMessage();
			}

			// response does not matter, since the hidden parameter is already
			// removed ant the attachment won't be connected to the form anymore
			$.ajax({
				type: 'POST',
				url: $this.getUrl(),
				cache: false,
				data: {
					uuid: uuid,
					randomToken: $this.randomFormToken
				}
			});
		},

		getFrameName: function () {
			return 'UploadFrame' + this.getName();
		},

		uploadFile: function (field) {
			this.prepareField(field);

			if (!this.frame) {
            	this.frame = $('#'+this.getFrameName());
            }

			// create iframe:
			if (this.frame) {
				this.frame.remove();
				this.frame = null;
			}
			this.frame = $('<iframe id="' + this.getFrameName() + '" name="' + this.getFrameName() + '" style="display: none">');
			$(document.body).append(this.frame);
			this.frame.on('load', $.proxy(this.loadHandler, this));

			var inputFieldName = $('<input>').attr('type', 'hidden').attr('name', 'fieldName').val(this.getName()),
				formTokenField = $('<input>').attr('type', 'hidden').attr('name', 'randomToken').val(this.randomFormToken),
				actionProviderField = $('<input>').attr('type', 'hidden').attr('name', 'actionProvider').val(this.actionProvider),
				charsetField = $('<input>').attr('type', 'hidden').attr('name', '_charset_').val('UTF-8'),
				formPathField = $('<input>').attr('type', 'hidden').attr('name', 'formPath').val(this.getFormParameter(':formstart'));

			// create form:
			if (this.form) {
				this.form.remove();
				this.form = null;
			}
			this.form = $('<form method="post" action="' + this.getUrl() + '" enctype="multipart/form-data" target="' + this.getFrameName() + '" style="display: none">');
			this.form.append(field);
			if (!this.form.html()) { // for IE8 and lower
				this.form = $('<form>').attr('method', 'post').attr('action', this.getUrl()).attr('enctype', 'multipart/form-data').attr('target', this.getFrameName()).attr('style', 'display: none');
				this.form.append(field);
			}
			this.form.append(inputFieldName).append(formTokenField).append(actionProviderField).append(formPathField).append(charsetField);

			$(document.body).append(this.form);

			this.form.submit();
		},

		getFormParameter: function (parameterName) {
			if (!this.currentForm) {
				this.currentForm = this.$ctx.parents('form');
			}
			return $('input[name="' + parameterName + '"]', this.currentForm).val();
		},

		prepareField: function (field) {
			this.originalFieldName = field.attr('name');
			if (!this.originalFieldPlaceholder) {
				this.originalFieldPlaceholder = $('<span style="display: none"/>');
				this.originalFieldPlaceholder.insertBefore(field);
			}
			this.originalField = field.attr('name', 'file').detach();
			this.showLoadingIndicator();
		},

		resetField: function () {
			this.originalField.attr('name', this.originalFieldName);
			this.showLoadingIndicator(false);
			this.originalField.clone(true).insertAfter(this.originalFieldPlaceholder);
		},

		showLoadingIndicator: function (show) {
			if (!this.loadingIndicator) {
				this.loadingIndicator = $('.js-loading-indicator', this.$ctx);
			}
			if (show === false) {
				this.loadingIndicator.hide();
			} else {
				this.loadingIndicator.show();
			}
		},

		loadHandler: function () {
			var content = this.frame.contents().find('#content');
			if (content.length > 0) {
				this.resetField();
				this.uploadResponseHandler(content.data('response'));
			}
		},

		/**
		 * Singleton for size limit for attachments in the whole form/page
		 */
		SizeCalculator: {
			init: function (limit, fileLimit) {
				if (!this.initialized) {
					this.initialized = true;
					this.sizeLimit = limit;
					if (!this.sizeLimit) {
						this.sizeLimit = -1;
					}
					this.fileSizeLimit = fileLimit;
					if (!this.fileSizeLimit) {
						this.fileSizeLimit = -1;
					}
					this.size = 0;
				}
			},

			getSizeLimit: function () {
				return this.sizeLimit;
			},

			getFileSizeLimit: function () {
				return this.fileSizeLimit;
			},

			add: function (size) {
				this.size += size;
				if (this.fileSizeLimit >= 0 && this.fileSizeLimit < size) {
					return this.getStatus(false, size - this.fileSizeLimit);
				}
				return this.getStatus();
			},

			remove: function (size) {
				this.size -= size;
				return this.getStatus();
			},

			getStatus: function (fileSizeStatusOk, fileOverhead) {
				var overhead = this.size - this.sizeLimit;
				fileOverhead = typeof fileOverhead === 'undefined' ? 0 : fileOverhead;
				fileSizeStatusOk = fileSizeStatusOk !== false ? true : false;
				if (this.sizeLimit >= 0 && overhead > 0) {
					return {
						ok: false,
						fileOk: fileSizeStatusOk,
						overhead: overhead,
						fileOverhead: fileOverhead
					};
				}
				return {
					ok: true,
					fileOk: fileSizeStatusOk,
					overhead: 0,
					fileOverhead: fileOverhead
				};
			}
		}
	});
}(Tc.$, window.doT));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.FileUpload.js
// module id = 276
// module chunks = 0